export const CURRENCYSELECT = 'HEADER::CURRENCYSELECT';
export const CURRENCYOBJECT = 'HEADER::CURRENCYOBJECT';
export const LANGUAGESELECT = 'HEADER::LANGUAGESELECT';
export const PAGESELECT = 'HEADER::PAGESELECT';
export const PAGEPARAM = 'HEADER::PAGEPARAM';
export const DATABASE = 'DATABASE::FULLLOAD';
export const USERSDATABASE = 'USERSDATABASE::FULLLOAD';
export const REGIONSDATABASE = 'REGIONSDATABASE::FULLLOAD';
export const REGIONSUPDATE = 'REGIONSDATABASE::UPDATE';
export const OBJECT = 'CARD::OBJECT';
export const EDITOBJECT = 'CARD::EDITOBJECT';
export const EDITOBJECTCHECKBOX = 'CARD::EDITOBJECTCHECKBOX';
export const EDITOBJECTSELECT = 'CARD::EDITOBJECTSELECT';
export const SORTERVALUE = 'CARD::SORTERVALUE';
export const AGREEMENTVALUE = 'LANDLORDS::AGREEMENTVALUE';
export const TYPING = 'LANDLORDS::TYPING';
export const SECRETTYPING = 'LANDLORDS::SECRETTYPING';
export const CHECK = 'LANDLORDS::CHECK';
export const SELECT = 'LANDLORDS::SELECT';
export const MAINSELECT = 'MAIN::SELECT';
export const CLEAR_INPUTS = 'LANDLORDS::CLEAR_INPUTS';
export const MAIN_RESET_INPUTS = 'MAIN::RESET_INPUTS';
export const SEARCHTYPING = 'SEARCH::TYPING';
export const SEARCHCHECK = 'SEARCH::CHECK';
export const SEARCHSELECT = 'SEARCH::SELECT';
export const SEARCH_CLEAR_INPUTS = 'SEARCH::CLEAR_INPUTS';
